import { GetterTree } from 'vuex';

import { StateType } from './state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const moduleGetters: GetterTree<StateType, any> = {
  exists(state) {
    return !!state.session;
  },
  sessionId(state) {
    return state.session?.id
  },
  userId(state) {
    return state.session?.userId;
  },
  role(state) {
    return state.profile?.role;
  },
  email(state) {
    return state.profile?.email;
  },
  jidNode(state) {
    return state.session?.jidNode
  },
  title(state) {
    return state.profile?.title
  },
  sessionName(state) {
    return state.profile?.name
  },
  sessionToken(state) {
    return state.session?.token;
  },
  id(state) {
    return state.session?.id
  }
};

export default moduleGetters;
